import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { CommonState, selectUserFlag } from '@patient-help-center/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  destroyed = new Subject();
  // Footer Date
  appYear: number = new Date().getFullYear();
  isRegisteredUser = false;
  // Footer Section collapse
  public isCollapsed = {
    footerSection1: false,
    footerSection2: false,
    footerSection3: false,
  };
  active: boolean[] = [false, false, false];

  constructor(private commonStore: Store<CommonState>, public router: Router) {}

  ngOnInit(): void {
    this.commonStore
      .select(selectUserFlag)
      .pipe(takeUntil(this.destroyed))
      .subscribe((userFlag) => {
        if (userFlag === 'r') {
          this.isRegisteredUser = true;
        }
      });
  }

  toggleSection(i: number) {
    this.active[i] = !this.active[i];
  }
  
  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
